import { render, staticRenderFns } from "./MobilePage.vue?vue&type=template&id=5e4d2164&scoped=true"
import script from "./MobilePage.vue?vue&type=script&lang=js"
export * from "./MobilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d2164",
  null
  
)

export default component.exports